<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false" :class-name="z100000">
      <h3 slot="header" class="modal-header">图片上传</h3>
      <div style="display: flex;flex-wrap: wrap">
        <template v-for="item in data " v-if="data">
          <div class="fileItem">
            <div style="margin-bottom: 10px;">
              <img class="file-img" :src="item.attachmentImgUrl" alt="">
              <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem(item)">删除</a>
            </div>
            <Input class="input-width" v-model="item.attachmentClickUrl" placeholder="跳转地址必填" v-if="link==1"/>
            <Input class="input-width" v-model="item.remark" placeholder="描述信息必填" v-if="remark==1"/>
          </div>
        </template>
        <div class="fileItem">
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="formatError"

          >
            <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
          </Upload>

        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {
    labelgetConfigImg,
    labeladdConfigImg,
    labeleditConfigImg,
    labelremoveConfigImg
  } from "../../../../api/projectConfig";

  export default {
    name: "ImgUpload",
    props: {
      n: {
        type: Number,
        default: 0
      },
      fid: {
        type: String,
        default: ''
      },
      orderId: {
        type: Number,
        default: 0
      },
      pics:{
        type:Array,
        default(){
          return []
        }
      },
      num:{
        type:Number,
        default:0
      },
      maxnum:{
        type:Number,
        default:0
      },
      link:{
        type:Number,
        default:0
      },
      remark:{
        type:Number,
        default:0
      }
    },
    watch: {
      n() {
        this.data=[]
        if(this.pics.length > 0){
          this.data = this.pics
        }
        this.labelgetConfigImg()
        this.isShow = true
      },
    },
    data() {
      return {
        isShow: false,
        data: [],
        loading: true,
        token: '',
        baseUrl: '',
        z100000: 'z100000',
      }
    },
    methods: {
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      labelgetConfigImg() {
        if (!this.fid) {
          return
        }
        let params = {
          fid: this.fid
        }
        labelgetConfigImg(params).then(res => {
          this.data = res.data
        }).catch(error=>{})
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      handleError() {

      },
      handleSuccess(res) {
        let params = {
          fid: res.data.fid,
          attachmentImgUrl: res.data.url,
          moduleFid: this.fid,
          proHouseTypeFid:this.projectFid,
          type:1,
          order:this.orderId
        }
        if(this.data.length >= this.maxnum && this.maxnum >0){
          this.$Message.error('最多上传'+this.maxnum+'张图片')
          this.changeLoading();
          return
        }
        if (!this.fid) {
          this.data.push(params)
          return
        }
        labeladdConfigImg(params).then(res1 => {
          this.data.push(res1.data)
        }).catch(error=>{})
      },
      deleteItem(item) {
        if(this.data.length <= this.num && this.num > 0 && !(this.num == this.maxnum)){
          this.$Message.error('至少保留'+this.num+'张图片')
          this.changeLoading();
          return
        }
        if(!this.fid){
          this.data = this.data.filter(v => v.attachmentImgUrl !== item.attachmentImgUrl)
          this.changeLoading();
          return
        }
        let params = {
          fid: item.fid
        }
        labelremoveConfigImg(params).then(res => {
          this.labelgetConfigImg()
        }).catch(error=>{})

      },
      ok() {
        if(this.data.length < this.num && this.num > 0){
          this.$Message.error('至少保留'+this.num+'张图片')
          this.changeLoading();
          return
        }
        let isNull=false
        this.data.forEach((ele, index) => {
          if(this.link == 1 && !ele.attachmentClickUrl){
            isNull = true
            return
          }
          if(this.remark == 1 && !ele.remark){
            isNull = true
            return
          }
          ele['attachmentOrder'] = index
        })
        if(isNull){
          this.$Message.error('请填写必填项')
          this.changeLoading();
          return
        }
        if(!this.fid){
          this.$emit('pic', this.data)
          this.isShow = false
          return
        }
        if(this.data.length < 1){
          this.isShow = false
          this.$Message.success('图片配置成功')
          return
        }
        labeleditConfigImg(this.data).then(res => {
          this.isShow = false
          this.$Message.success('图片配置成功')
        }).catch(error=>{})
      },
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 150px;
    height: 85px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }

  .fileItem {
    margin-right: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;

  }

  .file-img {
    width: 150px;
    height: 85px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 150px;
    margin-bottom: 10px;
  }


</style>
